import * as React from 'react';
import Button from 'react-bootstrap/Button';

import './style.scss';

interface IDeleteButtonProps {
  onClick: TButtonOnClick;
  className?: string;
  isDisabled?: boolean;
}

interface IDeleteButtonState {}

export default class DeleteButton extends React.Component<IDeleteButtonProps, IDeleteButtonState> {
  render() {
    const { onClick, className } = this.props;

    return (
      <Button
        className={`delete-btn ${className || ''}`}
        onClick={(event) => onClick(event)}
        disabled={this.props.isDisabled}
      />
    );
  }
}
